// extracted by mini-css-extract-plugin
export default {"textWrap":"ExclusaoPlanoForm_textWrap__cI3cu","margin":"ExclusaoPlanoForm_margin__d5kO5"};